export const WALLET_EXPERIMENT_KEY = "wallet-enablement-v1";

export const VARIANT_TREATMENT = "treatment";
export const VARIANT_CONTROL = "control";
